import { ScalingReasonCode, StorageAction } from '@cast/types-stop';
import dayjs from 'dayjs';
import { DimensionChange } from 'features/cluster/storage-optimization/pv-events/types';
import round from 'lodash/round';
import {
  ACTION_TYPE_TO_DIMENSION_MAP,
  ACTION_TYPE_TO_DIRECTION_MAP,
} from 'features/cluster/storage-optimization/pv-events/constats';

export const resolveMetricsStep = (
  startTime?: string,
  endTime?: string
): '1m' | '5m' | '1h' => {
  if (!startTime || !endTime) {
    return '1h';
  }

  if (dayjs(startTime).isAfter(dayjs(endTime))) {
    return '1h';
  }

  const hourDiff = dayjs(endTime).diff(dayjs(startTime), 'hours');

  return hourDiff < 5 ? '1m' : hourDiff < 48 ? '5m' : '1h';
};

export const computeDeltaPercentage = (change: DimensionChange): number => {
  if (change.before === 0) {
    return 0;
  }

  const delta = ((change.after - change.before) / change.before) * 100;

  return round(delta, 2);
};

export const getActionOperationTitles = (action: StorageAction): string[] => {
  const hasPrevDisk =
    action.prevDisk?.sizeBytes ||
    action.prevDisk?.iops ||
    action.prevDisk?.throughput;

  if (!hasPrevDisk) {
    return ['Cloud disk creation'];
  }

  const reasons = action.reasons;

  if (!reasons) {
    return [];
  }

  return reasons.map(({ code }) => {
    const normalizedCode =
      code ?? ScalingReasonCode.SCALING_REASON_CODE_UNSPECIFIED;

    return `${ACTION_TYPE_TO_DIMENSION_MAP[normalizedCode]} ${ACTION_TYPE_TO_DIRECTION_MAP[normalizedCode]}`;
  });
};
